<div class="login_bg">
        <!-- Form Section Start -->
        <div class="inner_container"> 
            <div class="login_form_wrapper">
                <div class="login_form_bg"><a href="login" class="logo" title="ManpowerGroup logo"></a></div>
                <div class="login_form">
                    <div class="login_header_right">
                        <h1>{{'ResetPassword.IniTITLE' | translate}}</h1>
                        
                    </div>
                    <!-- Login form Start-->
                    <form [formGroup]="resetPwd">
                        <!-- ブラウザのパスワードマネージャー向けの非表示ユーザー名フィールド -->
                        <input type="text" name="username" autocomplete="username" style="display:none" aria-hidden="true">
                        <!-- <div class="mb-4">
                            <label for="userName" class="form-label">{{'ResetPassword.LOGINID' | translate}}</label>
                            <div class="input-group login_id">
                                <input type="text" class="form-control" id="loginId" formControlName="loginId"
                                name="loginId" required aria-describedby="login_id" placeholder="{{'ResetPassword.LOGINID' | translate}}" readonly>
                                <span><i class="bi bi-person"></i></span>
                                <small *ngIf="resetPwd.controls['loginId'].dirty && resetPwd.hasError('required','loginId')" class="text-danger mt-1">*{{"ResetPassword.err5" | translate}}</small>
                            </div>
                        </div> -->
                        <div class="mb-4">
                            <label for="userName" class="form-label">{{'ResetPassword.OLDPASSWORD' | translate}}</label>
                            <div class="input-group login_id">
                                <input type="password" class="form-control" id="oldPassword" formControlName="oldPassword"
                                name="oldPassword" required aria-describedby="login_id" autocomplete="current-password" placeholder="{{'ResetPassword.OLDPASSWORD' | translate}}">
                                <span><i class="bi bi-lock"></i></span>
                                <small *ngIf="resetPwd.controls['oldPassword'].dirty && resetPwd.hasError('required','oldPassword')" class="text-danger mt-1">*{{"ResetPassword.err4" | translate}}</small>
                            </div>
                        </div>
                        <div class="mb-4">
                            <label for="userName" class="form-label">{{'ResetPassword.NEWPASSWORD' | translate}}</label>
                            <div class="input-group login_id">
                                <input type="password" class="form-control" id="newPassword" formControlName="newPassword"
                                name="newPassword" required aria-describedby="login_id" autocomplete="new-password" placeholder="{{'ResetPassword.NEWPASSWORD' | translate}}">
                                <span><i class="bi bi-lock"></i></span>
                                <small *ngIf="resetPwd.controls['newPassword'].dirty && resetPwd.hasError('required','newPassword')" class="text-danger mt-1">*{{"ResetPassword.err1" | translate}}</small>
                                 <small *ngIf="resetPwd.get('newPassword')?.errors?.['minlength']"  class="text-danger mt-1">{{'CngPassword.err3' | translate}}&nbsp;</small>
                                 <small *ngIf="resetPwd.get('newPassword')?.errors?.['alphanumeric']"  class="text-danger mt-1">{{'CngPassword.err6' | translate}}</small>
                            </div>
                        </div>
                        <div class="mb-4">
                            <label for="password" class="form-label">{{'ResetPassword.RETYPENEWPASSWORD' | translate}}</label>
                            <div class="input-group login_id">
                                <input type="password" class="form-control" formControlName="retypeNewPassword" name="retypeNewPassword" aria-describedby="login_password" autocomplete="new-password" placeholder="{{'ResetPassword.RETYPENEWPASSWORD' | translate}}" (copy)="$event.preventDefault()"
                      (paste)="$event.preventDefault()">
                                <span><i class="bi bi-lock"></i></span>
                                <small *ngIf="resetPwd.controls['retypeNewPassword'].dirty && resetPwd.hasError('required','retypeNewPassword')" class="text-danger mt-1">*{{"ResetPassword.err2" | translate}}</small>
                                <small *ngIf="resetPwd.get('retypeNewPassword')?.errors?.['mismatch']" class="text-danger mt-1">*{{'CngPassword.err5' | translate}}</small>
                            </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col"><button type="button" class="btn btn-primary login" (click)="resetPwdFrm()">{{'ResetPassword.SETBUTTON' | translate}}</button></div>
                            
                        </div>
                    </form>
                    <!-- Login form Start-->

                </div>
            </div>
        </div>
        <!-- Form Section End -->
</div>         

